import React, { useEffect, useState } from "react";

import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router";

import * as actions from "../../../store/actions";

import ViewProfileIcon from "../../../assets/icons/profileDropdownIcons/viewProfileIcon";
import DisconnectIcon from "../../../assets/icons/profileDropdownIcons/disconnectIcon";
import "tippy.js/dist/tippy.css"; // optional
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import {
  DropdownMenuStyled,
  DropdownToggleStyled,
  ButtonStyled,
  StyledConnectingButton,
  UserInfo,
  StyledTooltip,
} from "../style";
import Dropdown from "react-bootstrap/Dropdown";
import Avatar from "../../styled/Avatar/Avatar";
import PropTypes from "prop-types";
import MiniLoader from "../../MiniLoader";
import ArrowIcon from "../../ArrowIcon/ArrowIcon";
import { copyToClipboard } from "../../../common/helpers/helper";
import { OverlayTrigger } from "react-bootstrap";
import { getChainDataByChainId } from "../../../utils";

const popperConfig = {
  modifiers: [
    {
      name: "offset",
      enabled: true,
      options: {
        offset: [-30, 10],
      },
    },
  ],
};

function ConnectButton({ isLogin, toggleWalletList, currentChainId }) {
  const [loading, setLoading] = useState(true);

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(actions.checkIfLoginAndUpdateState(setLoading));
  }, [dispatch]);

  if (loading) {
    return <ConnectingButton />;
  } else if (isLogin) {
    return <ConnectedButton currentChainId={currentChainId} />;
  } else {
    return <ConnectInitiateButton toggleWalletList={toggleWalletList} />;
  }
}

export default ConnectButton;

ConnectButton.propTypes = {
  isLogin: PropTypes.bool,
  toggleWalletList: PropTypes.func,
  currentChainId: PropTypes.number,
  chainInfo: PropTypes.shape({
    id: PropTypes.number,
    network: PropTypes.string,
  }),
};

const ConnectInitiateButton = ({ toggleWalletList }) => {
  const dispatch = useDispatch();
  const loginState = useSelector((state) => state.login);
  const { requestStatus } = loginState;

  const connectWalletBtnHandler = () => {
    if (requestStatus) {
      dispatch(actions.setLoginLoading(true));
    } else {
      toggleWalletList();
    }
  };

  return (
    <button className="btn btn-brand-header text-nowrap mr-3 connect-wallet-btn" onClick={connectWalletBtnHandler}>
      CONNECT WALLET
    </button>
    // <ButtonStyled
    //   color="secondary"
    //   transparent
    //   outline
    //   onClick={connectWalletBtnHandler}
    //   $width={"17rem"}
    // >
    //   <span>Connect Wallet</span>
    // </ButtonStyled>
  );
};

ConnectInitiateButton.propTypes = {
  toggleWalletList: PropTypes.func,
};

const ConnectingButton = () => {
  return (
    <StyledConnectingButton>
      <p>Connecting...</p>
      <div className="loader-wrap">
        <MiniLoader width="1.6rem" />
      </div>
    </StyledConnectingButton>
  );
};

const ConnectedButton = ({ currentChainId }) => {
  const globalState = useSelector((state) => state.global);
  const userState = useSelector((state) => state.user);
  const loginState = useSelector((state) => state.login);
  const dispatch = useDispatch();

  const { token } = loginState;
  const { userData } = userState ?? {};
  const { account } = globalState;

  const history = useHistory();

  const disconnectHandler = () => dispatch(actions.logout(token, history));

  const menuOptions = [
    {
      label: `View on ${getChainDataByChainId(currentChainId)?.name}`,
      Icon: ViewProfileIcon,
      onClickHandler: () => window.open(getChainDataByChainId(currentChainId)?.url + "/address/" + account),
    },
    {
      label: "Disconnect",
      Icon: DisconnectIcon,
      onClickHandler: disconnectHandler,
    },
  ];

  function success() {
    toast("Address Copied");
  }

  function failed() { }

  return (
    <Dropdown className="flex">
      <UserInfo>
        {/* currentChainId === chainInfo?.id ? '' : 'error-net' */}
        <div className={`balance `}>
          {/* {currentChainId === chainInfo?.id || !chainInfo
              ? `${globalState.balance} ETH`
              : 'Wrong network'} */}
          {globalState.balance} {getChainDataByChainId(currentChainId)?.currency}
        </div>
        <OverlayTrigger
          placement="bottom"
          overlay={<StyledTooltip>{globalState.account}</StyledTooltip>}
        >
          <div
            className="account-number"
            onClick={() =>
              copyToClipboard(globalState.account, success, failed)
            }
          >
            {globalState.account}
          </div>
        </OverlayTrigger>
      </UserInfo>
      <Dropdown.Toggle
        as={DropdownToggleStyled}
        id="dropdown-custom-components"
      >
        <Avatar
          $width="4rem"
          $height="4rem"
          className="user-profile"
          $imgURL={'https://i.imgur.com/k9Sb17p.png'}
          $connectBtn
        />
      </Dropdown.Toggle>
      <DropdownMenuStyled popperConfig={popperConfig}>
        {menuOptions.map(
          (
            { label, Icon, onClickHandler, itemClass, iconProps, arrow = true },
            i
          ) => (
            <Dropdown.Item
              className={`${itemClass ? ` ${itemClass}` : ""}`}
              onClick={onClickHandler}
              key={label + i}
              as={i === 0 ? "a" : "a"}
            >
              {Icon && <Icon {...iconProps} className="dropdown-item-icon" />}
              <span style={{ fontSize: "12px", marginLeft: "6px" }}>
                {label}
              </span>{" "}
              {arrow && (
                <ArrowIcon direction={"right-up"} className="arrow-icon" />
              )}
            </Dropdown.Item>
          )
        )}
      </DropdownMenuStyled>
    </Dropdown>
  );
};

ConnectedButton.propTypes = {
  currentChainId: PropTypes.number,
};
